import { render } from "./NotificationItems.vue?vue&type=template&id=230bf810"
import script from "./NotificationItems.vue?vue&type=script&lang=js"
export * from "./NotificationItems.vue?vue&type=script&lang=js"
script.render = render

export default script